export enum SupportedLanguage {
  English = 'en',
  MandarinChinese = 'zh',
  Spanish = 'es',
  Hindi = 'hi',
  Arabic = 'ar',
  French = 'fr',
  Portuguese = 'pt',
  Japanese = 'ja',
}

export const LanguageDisplayNames = {
  [SupportedLanguage.English]: 'English',
  [SupportedLanguage.MandarinChinese]: 'Mandarin Chinese',
  [SupportedLanguage.Spanish]: 'Spanish',
  [SupportedLanguage.Hindi]: 'Hindi',
  [SupportedLanguage.Arabic]: 'Arabic',
  [SupportedLanguage.French]: 'French',
  [SupportedLanguage.Portuguese]: 'Portuguese',
  [SupportedLanguage.Japanese]: 'Japanese',
};
